module.exports = __webpack_public_path__ + "static/media/nonprofit-landscape.a077df9e.jpg";